module.exports = __webpack_public_path__ + "img/storeVisit_pic.b689f141.png";